import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["singleMode", "arrayMode", "modeInput", "toggleLabel", "singleInput"]

    toggle() {
        const isArray = this.modeInputTarget.value === "array"

        if (isArray) {
            // Switch to single mode
            this.modeInputTarget.value = "single"
            this.singleModeTarget.classList.remove("hidden")
            this.arrayModeTarget.classList.add("hidden")
            this.toggleLabelTarget.textContent = "Multiple"
        } else {
            // Switch to array mode
            this.modeInputTarget.value = "array"
            this.singleModeTarget.classList.add("hidden")
            this.arrayModeTarget.classList.remove("hidden")
            this.toggleLabelTarget.textContent = "Single"
            // Clear single input so it doesn't conflict
            if (this.hasSingleInputTarget) {
                this.singleInputTarget.value = ""
            }
        }
    }
}
